export const BREAKPOINT = {
  LAPTOP: '991px',
  TABLE: '767px',
  MOBILE: '575px'
}
